// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1ab034e4","247":"23a099bb","706":"16fc50b5","869":"89d8b2cb"}[chunkId] + ".chunk.js";
};